import React from 'react'
import { Spinner } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";

import Back from 'shared/assets/images/svg/back_blue.svg'
import Input from 'shared/component/inputFields'

import { useLogin } from "auth/login/login.service";
import { useTranslation } from 'react-i18next';

const Login = () => {
  const {t} = useTranslation();
  const {register,onSubmit,formState:{errors},isLoading,isLoggedIn,serverErrors} = useLogin();

  if(isLoggedIn) return <Navigate to='/' />

  return (
    <div className='login'>
      <div className='container'>
        <div className='row'>
          <div className='col-lg-5 col-md-10 mx-auto'>
            <form onSubmit={e => {
              e.preventDefault();
              onSubmit();
            }} className='box-login'>
                <div className='page-header'>
                    <div className='header-info'>
                    <Link to="/"><img src={Back} alt="" /></Link>
                    <h1 className='title'>{t('login.sign-in')}</h1>
                    </div>
                </div>
                <Input type="text" label={t('login.username')} {...register('username')} error={errors.username?.message ?? serverErrors['UserName']} />
                <Input type="password" label={t('login.password')} {...register('password')} error={errors.password?.message ?? serverErrors['Password']}/>
                <div className='remember'>
                  <label className='login-check' htmlFor='rem'>
                      <input type="checkbox" id="rem" {...register('rememberMe')}/>
                      <span>{t('login.remember-me')}</span>
                  </label>
                  <Link to="/reset-password">{t('login.forgot-password')}</Link>
                </div>
                <button disabled={isLoading} className='btn-blue col-12' type='submit'>
                  <Spinner animation='border' size='sm' hidden={!isLoading} />
                  {t('login.sign-in')}</button>
                <Link className='signup' to="/signup">{t('login.dont-have-an-account-yet')}</Link>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Login